import React, { useCallback } from 'react';

import { className, Text, ImageComponent } from 'aplazame-design-system';
import ArrowLink from '../ArrowLink';
import style from './style.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';

export default function CardStoreComponent({
    title,
    description,
    descriptionNode,
    showDescription,
    tags,
    url,
    linkTitle,
    image,
    logo,
    aspectRatioDesktop,
    min,
    utm,
    allStores,
    formSearch,
    _onBlur
}) {
    const finalUrl = `${url}${utm ? `${url.indexOf('?') !== -1 ? '&' : '?'}${utm}` : ''
        }`;

    const goToSite = useCallback(() => {
        window.open(finalUrl);
    }, [finalUrl]);

    return (
        <div
            {...className([style['card-store-container']].join(' '))}
            onClick={goToSite}
        >
            <div
                {...className(
                    [
                        style['image-wrapper'],
                        min
                            ? style['image-wrapper--min']
                            : colorStyle['after-dark--primary'],
                        'mb-1',
                        min ? 'mb-lg-4' : '',
                    ].join(' ')
                )}
            >
                <ImageComponent
                    store={true}
                    image={image}
                    className={`${style.image} ${style.fixFeatureStores} ${allStores ? style.fixAllStores : ""} 
                     ${formSearch ? style.fixFormStores : ""} ${aspectRatioDesktop && aspectRatioDesktop !== 1.2
                            ? 'd-lg-none'
                            : ''
                        }`}
                    aspectRatio={1.2}
                />
                {aspectRatioDesktop && aspectRatioDesktop !== 1.2 ? (
                    <ImageComponent
                        store={true}
                        image={image}
                        className={`${style.image} d-none d-lg-block ${style.fixFeatureStores}`}
                        aspectRatio={aspectRatioDesktop}
                    />
                ) : null}
                <div className={style['image-wrapper__logo']}>
                    <ImageComponent className={`${style.fixLogo}`} store={true} image={logo} />
                </div>
            </div>
            {!min ? (
                <Text
                    tag="span"
                    {...className(
                        `${colorStyle['color--primary']} d-block mt-3 mb-1 ${style.categoryName}`
                    )}
                >
                    {tags && tags.length
                        ? tags.map((t) => t.title).join(', ')
                        : ' '}
                </Text>
            ) : null}
            {min ? (
                <a
                    onBlur={_onBlur}
                    href={finalUrl}
                    target="_blank"
                    // title={linkTitle}
                    {...className('h4', style.storeName)}
                    rel="noopener nofollow"
                    aria-label={linkTitle + ' (se abre en una nueva pestaña)'}
                >
                    {title}
                </a>
            ) : (
                <ArrowLink
                    className={style.storeName}
                    href={finalUrl}
                    target="_blank"
                    // title={linkTitle}
                    rel="noopener nofollow"
                    aria-label={linkTitle + ' (se abre en una nueva pestaña)'}
                >
                    {title}
                </ArrowLink>
            )}
            {(showDescription && descriptionNode) ? <Text
                tag="span"
                {...className(
                    `d-block mt-3 mb-1 ${style.categoryName} ${min ? style.storeDescriptionMin : style.storeDescription}`
                )}
            >
                {descriptionNode.childMarkdownRemark.htmlWithoutWrapper}
                {/* {description} */}
            </Text> : null}
        </div>
    );
}
